import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import NahlasenieChybyItems from '../model/NahlasenieChybyItems';

const mapResponse = (data: object): NahlasenieChybyItems => ({
  // @ts-ignore
  popis: data?.results[0]?.popis,
  // @ts-ignore
  upozornenie: data?.results[0]?.upozornenie,
});

export const getNahlasenieChyby = async ():
  Promise<ClientResponse<NahlasenieChybyItems>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/nahlasenie-chyby',
  );

  return {
    data: mapResponse(data),
    responseCode: status,
  };
};
